/**
 * Returns true when the given URL cannot be embedded in the current page.
 *
 * Rule:
 *  - HTTP platform  → both http:// and https:// app URLs are allowed.
 *  - HTTPS platform → only https:// app URLs are allowed; http:// is blocked
 *    by the browser's mixed-content policy and must not be opened at all.
 */
export function isUrlPreviewBlocked(url: string): boolean {
  return window.location.protocol === 'https:' && url.startsWith('http:');
}
